import { render, staticRenderFns } from "./BuySingleAccesses.vue?vue&type=template&id=57ddc718&scoped=true&"
import script from "./BuySingleAccesses.vue?vue&type=script&lang=js&"
export * from "./BuySingleAccesses.vue?vue&type=script&lang=js&"
import style0 from "./BuySingleAccesses.vue?vue&type=style&index=0&id=57ddc718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ddc718",
  null
  
)

export default component.exports